// extracted by mini-css-extract-plugin
export var fakePosition = "fakePosition__QsMQ";
export var fifth = "fifth__LvH_";
export var firmsContainer = "firmsContainer__zrKy";
export var first = "first__gINQ";
export var fourth = "fourth__s1hF";
export var iconLoading = "iconLoading__UzI_";
export var iconsLoadingContainer = "iconsLoadingContainer__MRR_";
export var position = "position__g7fL";
export var ratingRowLoadingMobileContainer = "ratingRowLoadingMobileContainer__cFSW";
export var rowsContainer = "rowsContainer__FvkN";
export var second = "second__YZNx";
export var shape = "shape__Mhw8";